import { queryOptions } from "@tanstack/react-query";

import {
  getAllPublicCases,
  getCasesByTag,
  getPublishedBlogPost,
  getPublishedBlogPosts,
  getPublishedCase,
  getPublishedClientLogos,
  getPublishedTestimonials,
  getRelatedBlogPosts,
  type PublicBlogListItem,
  type PublicBlogPost,
  type PublicCase,
  type PublicCaseListItem,
  type PublicClientLogo,
  type PublicTestimonial,
  type TestimonialCategory,
  type TestimonialMediaKind,
} from "@/lib/public-content.functions";
import { getLeadMagnetTeaser } from "@/lib/lead-magnets.functions";
import type { CaseTag } from "@/lib/cases/tags";

export type {
  PublicBlogListItem,
  PublicBlogPost,
  PublicCase,
  PublicCaseListItem,
  PublicClientLogo,
  PublicTestimonial,
  TestimonialCategory,
  TestimonialMediaKind,
};

export const testimonialsQueryOptions = queryOptions({
  queryKey: ["public", "testimonials"],
  queryFn: () => getPublishedTestimonials(),
  staleTime: 5 * 60 * 1000,
});

export const clientLogosQueryOptions = queryOptions({
  queryKey: ["public", "client_logos"],
  queryFn: () => getPublishedClientLogos(),
  staleTime: 5 * 60 * 1000,
});

export const blogPostsQueryOptions = queryOptions({
  queryKey: ["public", "blog_posts"],
  queryFn: () => getPublishedBlogPosts(),
  staleTime: 60 * 1000,
});

export function blogPostQueryOptions(slug: string) {
  return queryOptions({
    queryKey: ["public", "blog_post", slug],
    queryFn: () => getPublishedBlogPost({ data: { slug } }),
    staleTime: 60 * 1000,
  });
}

export function relatedPostsQueryOptions(category: string, excludeSlug: string, limit = 3) {
  return queryOptions({
    queryKey: ["public", "blog_posts", "related", category, excludeSlug, limit],
    queryFn: () => getRelatedBlogPosts({ data: { category, excludeSlug, limit } }),
    staleTime: 60 * 1000,
  });
}

export function casePostQueryOptions(slug: string) {
  return queryOptions({
    queryKey: ["public", "case", slug],
    queryFn: () => getPublishedCase({ data: { slug } }),
    staleTime: 60 * 1000,
  });
}

export function casesByTagQueryOptions(tag: CaseTag) {
  return queryOptions({
    queryKey: ["public", "cases", "by_tag", tag],
    queryFn: () => getCasesByTag({ data: { tag } }),
    staleTime: 5 * 60 * 1000,
  });
}

export function allPublicCasesQueryOptions() {
  return queryOptions({
    queryKey: ["public", "cases", "all"],
    queryFn: () => getAllPublicCases(),
    staleTime: 5 * 60 * 1000,
  });
}
/**
 * Ticket W14: Freebie-Anreißer auf Produktseiten. Kurze Frischezeit, damit ein
 * auf Entwurf gestelltes Freebie zügig aus den Seiten verschwindet.
 */
export function leadMagnetTeaserQueryOptions(slug: string) {
  return queryOptions({
    queryKey: ["public", "lead_magnet_teaser", slug],
    queryFn: () => getLeadMagnetTeaser({ data: { slug } }),
    staleTime: 60 * 1000,
  });
}
